/**
 * Document auto-numbering helpers — wraps the company-settings peek/advance
 * endpoints. Imported by SalesInvoices, DeliveryNotes, PurchaseOrders and
 * Payments to pre-fill the document-number input on "New …" and to bump
 * the per-series counter on a successful save.
 *
 * All four helpers fail silently — auto-numbering is a convenience layer
 * and must never block the underlying form action.
 */
import api from './api';

/** Peek the next formatted number for a series. Returns null when the
 *  feature is disabled for this company (the caller should then leave the
 *  field blank for the user to type manually). */
export async function peekNextNumber(series) {
  try {
    const res = await api.get(`/companies/numbering/peek?series=${encodeURIComponent(series)}`);
    if (!res?.data?.enabled) return null;
    return res.data.formatted || null;
  } catch {
    return null;
  }
}

/** Advance the counter for a series after a successful document save.
 *  Pass the actual number the user saved (so the counter is bumped past
 *  any manual override). No-op if the series is disabled server-side. */
export async function advanceNumber(series, usedNumber) {
  try {
    await api.post('/companies/numbering/advance', { series, used_number: usedNumber || null });
  } catch {
    /* fire-and-forget */
  }
}
